export default "__VITE_ASSET__a9NWV7ZzUDnozeb69v11FQ__"